"use strict";

import Vue from 'vue';
import axios from "axios";
import store from '../store/index';
import router from '../router';

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.BASE_URL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

let config = {
  baseURL: process.env.BASE_URL || process.env.apiUrl || "",
};

// Add a response interceptor which can catch errors in all axios calls
axios.interceptors.response.use(
    function(response) {
      // Do something with response data
        if (store.state.common.lastAttemptToReachServerFailed) {
            store.commit('common/setLastAttemptToReachServerFailed', false);
        }

        return response;
    },
    function(error) {
        if (!error.response) {
            store.commit('common/setLastAttemptToReachServerFailed', true);

            return Promise.reject(error);
        }

        if ("internal_message" in error.response.data) {
            console.log("Internal error message: " +  error.response.data.internal_message);
        }

        // Log the user out internally if the status code suggest that he/she is not logged in anymore.
        if (error.response.status == 401) {
            store.commit('auth/setLoggedIn', false);
            router.push({name: 'Login'});
        }
        else {
            return Promise.reject(error);
        }
    }
);

const _axios = axios.create(config);


// Plugin.install = function(Vue, options) {
Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
